import { FC } from "react";
import { ListStaffs } from "~/components/admin/operations";
import PageMeta from "~/components/common/meta";

type Props = {};

export const ScreenStaff: FC<Props> = () => {
  return (
    <>
      <PageMeta title="Staffs | Art Handler" description="Staff" />
      <ListStaffs />
    </>
  );
};
